import { render } from "./MemberDashboard.vue?vue&type=template&id=3687b4ab&scoped=true"
import script from "./MemberDashboard.vue?vue&type=script&lang=js"
export * from "./MemberDashboard.vue?vue&type=script&lang=js"

import "./MemberDashboard.vue?vue&type=style&index=0&id=3687b4ab&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3687b4ab"]])

export default __exports__